import videojs from 'video.js';

function handleError(errorCode: number, errorMessage: string, player: videojs.Player) {
  const errorMessages: {[key: number]: string} = {
    1: 'Você interrompeu a reprodução do vídeo',
    2: 'Um erro de rede causou uma falha no download do vídeo.',
    3: 'A reprodução do vídeo foi interrompida devido a um problema de corrupção ou porque o vídeo utiliza recursos não suportados pelo seu navegador.',
    4: 'Este vídeo está sendo processado e ficará disponível em breve.',
    5: 'O vídeo está criptografado e não temos as chaves para descriptografá-lo.',
  };

  const errorMessageCustomized = errorMessages[errorCode] || errorMessage;

  const error = {errorCode, errorMessage: errorMessageCustomized};
  if (!error || errorMessage === null) {
    return;
  }
  const errorWrapper = document.createElement('div');
  errorWrapper.className = 'scaleup-error-wrapper';

  const codeMessage = errorCode ? ' (Código ' + error.errorCode + ').' : '.';
  const errorIcon = document.createElement('p');
  errorIcon.innerText = 'Um erro foi detectado' + codeMessage;
  errorIcon.className = 'scaleup-error-code';

  const errorScreenText = document.createElement('span');
  errorScreenText.innerText = error.errorMessage;
  errorScreenText.className = 'scaleup-error-message';

  errorWrapper.appendChild(errorIcon);
  errorWrapper.appendChild(errorScreenText);

  const errorScreen = player.getChild('errorDisplay');
  resetAndPopulateErrorScreen(errorScreen);

  function resetAndPopulateErrorScreen(errorScreenEl: any) {
    errorScreenEl.el().replaceChildren('');
    if (errorScreen && errorScreen.el()) {
      errorScreen.el().appendChild(errorWrapper);
    }
  }
}

function handleEvent(eventName: string, player?: videojs.Player, addData?: any) {
  const bufferedPercentageEvents = ['progress', 'timeupdate'];

  if (bufferedPercentageEvents.includes(eventName) && player) {
    const buffPercentage = parseFloat(player.bufferedPercent().toFixed(2)) * 100;
    const currentTime = player.currentTime();
    const duration = player.duration();

    const event = {
      eventName: eventName,
      location: {
        origin: window?.location?.origin,
        href: window?.location?.href,
        videoId: (window?.location?.pathname).replace('/watch/', '').replace('/embed/', ''),
      },
      percentage: buffPercentage,
      currentTime,
      duration,
    };

    window.parent.postMessage(event, '*');
  } else {
    const event = {
      eventName: eventName,
      location: {
        origin: window?.location?.origin,
        href: window?.location?.href,
        videoId: (window?.location?.pathname).replace('/watch/', '').replace('/embed/', ''),
      },
      data: addData ? addData: {}
    };
    window.parent.postMessage(event, '*');
  }
}

function handleEventVideo(eventName: string, player?: HTMLVideoElement, addData?: any) {
  const bufferedPercentageEvents = [
    'progress',
    'timeupdate',
    'volumechange',
    'play',
    'playing',
    'pause',
    'seeking',
    'seeked',
    'ratechange',
    'ended',
    'waiting',
    'error'
  ];

  if (bufferedPercentageEvents.includes(eventName) && player) {
    const buffPercentage = player.buffered.length ? player.buffered.end(0) / player.duration * 100 : 0;
    const currentTime = player.currentTime;
    const duration = player.duration;

    const event = {
      eventName: eventName,
      location: {
        origin: window?.location?.origin,
        href: window?.location?.href,
        videoId: (window?.location?.pathname).replace('/watch/', '').replace('/embed/', ''),
      },
      percentage: isNaN(buffPercentage) ? 0 : buffPercentage,
      currentTime,
      duration,
      playbackRate: player.playbackRate,
      volume: player.volume,
    };

    window.parent.postMessage(event, '*');
  } else {
    const event = {
      eventName: eventName,
      location: {
        origin: window?.location?.origin,
        href: window?.location?.href,
        videoId: (window?.location?.pathname).replace('/watch/', '').replace('/embed/', ''),
      },
      data: addData ? addData: {}
    };
    window.parent.postMessage(event, '*');
  }
}


export {handleEvent, handleEventVideo, handleError};
